import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import { SecondaryButton } from 'components/Shared/Button'
import Modal from 'components/Shared/Modal'
import AddIntegration from './AddIntegration'
import Integrations from './Integrations'
import ErrorFallback from 'components/Shared/ErrorFallback'
import { ErrorBoundary } from 'react-error-boundary'
import { useDataIntegrations } from './DataIntegrationsProvider'
import ErrorMessage from 'components/Shared/ErrorMessage'
import LoadingSpinner, { SpinnerSize } from 'components/Shared/LoadingSpinner'

export default function ManageIntegrations() {
  const { t } = useTranslation()
  const [manageModalOpen, setManageModalOpen] = useState(false)

  return (
    <ErrorBoundary FallbackComponent={ErrorFallback}>
      <div className="integrations_manage">
        <div className="integrations_manage__content d-flex flex-column align-items-center gap-3">
          <ManageIntegrationsModal isOpen={manageModalOpen} setOpen={setManageModalOpen} />
          <SecondaryButton
            color="navy"
            text={t('Settings.system.integrations.button')}
            classNames="settings-page_system__integrations-btn"
            onClick={() => setManageModalOpen(true)}
            fullWidth={false}
          />
        </div>
      </div>
    </ErrorBoundary>
  )
}

function ManageIntegrationsModal({ isOpen, setOpen }) {
  const { t } = useTranslation()
  const { integrations, loading, error } = useDataIntegrations()

  if (!isOpen) return null

  return (
    <Modal
      title={t('Integrations.manage.title')}
      fullWidth
      offWhiteBg
      contentClasses="integrations_manage__modal w-md-60"
      closeCallback={() => setOpen(false)}
      onClickOutside={() => setOpen(false)}
      mainContent={
        <div className="integrations_manage__modal__content">
          <p className="mt-3">{t('Integrations.manage.description')}</p>
          <article className="mt-3">
            <AddIntegration />
            {error.list && (
              <ErrorMessage classNames="mt-3" danger>
                {error.list}
              </ErrorMessage>
            )}
            {loading.list ? (
              <LoadingSpinner className="mt-3" size={SpinnerSize.SMALL} />
            ) : integrations?.length > 0 && (
              <>
                <h6 className="integrations_manage__modal__title">
                  {t('Integrations.manage.savedIntegrations')}
                </h6>
                <Integrations />
              </>
            )}
          </article>
        </div>
      }
    />
  )
}

ManageIntegrationsModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  setOpen: PropTypes.func.isRequired,
}
